import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../css/omstyle.css";
import AccordionReact from 'devextreme-react/accordion';
import { useLocation } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import FormField from '../../dynamicFormBuilder/FormField'
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import ValidationSummary from 'devextreme-react/validation-summary';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';


const searchpanel = [
  {
    ID: '1',
    Title: 'Search Filters'
  }
];

const defaultlayout = [
  {
    "groupId": 2,
    "label": "Group 2",
    "fields": [
      {
        "name": "TRANSACTIONTYPE_1_2",
        "tableName": "SMCHARGETRANSACTION",
        "label": "Transaction No. To:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONNUMBERFROM_1_2",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction No. From:",
        "role": [
          "Consignee",
          "SuperAdmin",
          "FPAdmin",
          "SODAdmin"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "field4_2",
        "tableName": null,
        "label": "field4",
        "role": null,
        "isLabelChanged": false,
        "type": "date",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "transactionFromaa_2",
        "tableName": "",
        "label": "Transaction No. From:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "PONUMBER_1_2",
        "tableName": "POORDERHEADER",
        "label": "Po Number contains:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "SHIPPER_2",
        "tableName": "FMTRACKINGNUMBERS",
        "label": "Ship To:",
        "role": null,
        "isLabelChanged": false,
        "type": "select",
        "options": [],
        "apiUrl": "xm/XMMonitor/GetTradingPartners",
        "grid": null,
        "required": true,
        "visible": true
      }
    ]
  },
  {
    "groupId": 1,
    "label": "Group 1",
    "fields": [
      {
        "name": "TRANSACTIONNUMBER_1_1",
        "tableName": "OMTRANSACTIONHEADER",
        "label": "Transaction No. From:",
        "role": [
          "SuperAdmin",
          "Consignee",
          "FPAdmin",
          "SODAdmin",
          "Carrier",
          "RNAAdmin",
          "InternalUser"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "RECORDTYPE_1_1",
        "tableName": "RRWAYBILLLADING",
        "label": "Checkbox Group:",
        "role": null,
        "isLabelChanged": false,
        "type": "checkboxGroup",
        "options": [
          "Option 1",
          "Option 2"
        ],
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "field2_1",
        "tableName": null,
        "label": "field2",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "AMOUNT_1_1",
        "tableName": "ACPAYMENTMETHOD",
        "label": "Amount:",
        "role": null,
        "isLabelChanged": false,
        "type": "number",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "RECORDTYPES1_1_1",
        "tableName": "RRWAYBILLLADING",
        "label": "Radio Group:",
        "role": null,
        "isLabelChanged": false,
        "type": "radio",
        "options": [
          "Option 1",
          "Option 2"
        ],
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONDUEDATETO_1_1",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction Date to:",
        "role": null,
        "isLabelChanged": false,
        "type": "date",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONDUEDATEFROM_1_1",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction Date from:",
        "role": null,
        "isLabelChanged": false,
        "type": "date",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "field1_1",
        "tableName": null,
        "label": "field1",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": false
      }
    ]
  },
  {
    "groupId": 3,
    "label": "Group 3",
    "fields": [
      {
        "name": "TRANSACTIONTYPE_1_3",
        "tableName": "SMCHARGETRANSACTION",
        "label": "Transaction No. To:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONNUMBERFROM_1_3",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction No. From:",
        "role": [
          "Consignee",
          "SuperAdmin",
          "FPAdmin",
          "SODAdmin"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "transactionFromaa_3",
        "tableName": "",
        "label": "Transaction No. From:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "PONUMBER_1_3",
        "tableName": "POORDERHEADER",
        "label": "Po Number contains:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "SHIPPER_3",
        "tableName": "FMTRACKINGNUMBERS",
        "label": "Ship To:",
        "role": null,
        "isLabelChanged": false,
        "type": "select",
        "options": [],
        "apiUrl": "xm/XMMonitor/GetTradingPartners",
        "grid": null,
        "required": true,
        "visible": true
      }
    ]
  },
  {
    "groupId": 4,
    "label": "Group 4",
    "fields": [
      {
        "name": "TRANSACTIONTYPE_1_4",
        "tableName": "SMCHARGETRANSACTION",
        "label": "Transaction No. To:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONNUMBERFROM_1_4",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction No. From:",
        "role": [
          "Consignee",
          "SuperAdmin",
          "FPAdmin",
          "SODAdmin"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "transactionFromaa_4",
        "tableName": "",
        "label": "Transaction No. From:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "PONUMBER_1_4",
        "tableName": "POORDERHEADER",
        "label": "Po Number contains:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "SHIPPER_4",
        "tableName": "FMTRACKINGNUMBERS",
        "label": "Ship To:",
        "role": null,
        "isLabelChanged": false,
        "type": "select",
        "options": [],
        "apiUrl": "xm/XMMonitor/GetTradingPartners",
        "grid": null,
        "required": true,
        "visible": true
      }
    ]
  },
  {
    "groupId": 5,
    "label": "Group 5",
    "fields": [
      {
        "name": "TRANSACTIONTYPE_1_5",
        "tableName": "SMCHARGETRANSACTION",
        "label": "Transaction No. To:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONNUMBERFROM_1_5",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction No. From:",
        "role": [
          "Consignee",
          "SuperAdmin",
          "FPAdmin",
          "SODAdmin"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "transactionFromaa_5",
        "tableName": "",
        "label": "Transaction No. From:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "PONUMBER_1_5",
        "tableName": "POORDERHEADER",
        "label": "Po Number contains:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "SHIPPER_5",
        "tableName": "FMTRACKINGNUMBERS",
        "label": "Ship To:",
        "role": null,
        "isLabelChanged": false,
        "type": "select",
        "options": [],
        "apiUrl": "xm/XMMonitor/GetTradingPartners",
        "grid": null,
        "required": true,
        "visible": true
      }
    ]
  },
  {
    "groupId": 6,
    "label": "Group 6",
    "fields": [
      {
        "name": "TRANSACTIONTYPE_1_6",
        "tableName": "SMCHARGETRANSACTION",
        "label": "Transaction No. To:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "TRANSACTIONNUMBERFROM_1_6",
        "tableName": "FMTRANSHEADER",
        "label": "Transaction No. From:",
        "role": [
          "Consignee",
          "SuperAdmin",
          "FPAdmin",
          "SODAdmin"
        ],
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "transactionFromaa_6",
        "tableName": "",
        "label": "Transaction No. From:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "PONUMBER_1_6",
        "tableName": "POORDERHEADER",
        "label": "Po Number contains:",
        "role": null,
        "isLabelChanged": false,
        "type": "text",
        "options": null,
        "apiUrl": null,
        "grid": null,
        "required": true,
        "visible": true
      },
      {
        "name": "SHIPPER",
        "name": "SHIPPER",
        "tableName": "FMTRACKINGNUMBERS",
        "label": "Ship To:",
        "role": null,
        "isLabelChanged": false,
        "type": "select",
        "options": [],
        "apiUrl": "xm/XMMonitor/GetTradingPartners",
        "grid": null,
        "required": true,
        "visible": true
      }
    ]
  }
];


function OMTransactionHistorySearchForm(props) {
  var accessToken = props.oidc.user.access_token;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [selectedTab, setSelectedTab] = useState(props.selectedTab);

  var currentUser = props.oidc.user;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get('id');
  const location = useLocation();
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [dataSource, setDataSource] = useState(null);
  const [forceRender, setForceRender] = useState(false); // State variable to force re-render

  const [editMode, setEditMode] = useState(false);
  const formRefs = useRef({});
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
    }
  }, []);
  const selectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus(prevStatus => !prevStatus);
    },
    [selectedItems]
  );

  const updateOption = (name, valueExpr, displayExpr, newOptions) => {
    console.log('Current Options:', formRefs.current[name].instance().option('dataSource'));
    if (formRefs.current[name]) {
      formRefs.current.SHIPPER.instance().option('dataSource', newOptions);
      formRefs.current.SHIPPER.instance().option('valueExpr', valueExpr);
      formRefs.current.SHIPPER.instance().option('displayExpr', displayExpr);

      formRefs.current.SHIPPER_5.instance().option('dataSource', newOptions);
      formRefs.current.SHIPPER_5.instance().option('valueExpr', valueExpr);
      formRefs.current.SHIPPER_5.instance().option('displayExpr', displayExpr);

      formRefs.current['PONUMBER_1_5'].instance().option('value', 'hassan');
      console.log('Updated Options:', formRefs.current[name].instance().option('items'));
      setForceRender(!forceRender);
    } else {
      console.warn('No formRef found for:', name);
    }
  }
  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const newOptions = [
    { id: 1, name: 'Option 1' },
    { id: 2, name: 'Option 2' },
    { id: 3, name: 'Option 3' }
  ];

  const handleFormSubmit = async (e) => {
    try {
      e.preventDefault()
      console.log(formFields);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  useEffect(() => {
    //fetchData();
  }, []);

  const [formFields, setformFields] = useState({
    TRANSACTIONNUMBER: "",
    TRANSACTIONDUEDATEFROM: "",
    TRANSACTIONDUEDATETO: "",
    TRANSACTIONTYPE: "",
    TRANSACTIONNUMBERFROM: "",
    AMOUNT: 0,
    PONUMBER: "",
    SHIPPER: "",
    SHIPPER_5: "",
    SHIPPER_4: "",
    RECORDTYPE: "",
    RECORDTYPES1: "",

    TRANSACTIONNUMBER_1: "",
    TRANSACTIONDUEDATEFROM_1: "",
    TRANSACTIONDUEDATETO_1: "",
    TRANSACTIONTYPE_1: "",
    TRANSACTIONNUMBERFROM_1: "",
    AMOUNT_1: 0,
    PONUMBER_1: "",
    RECORDTYPE_1: "",
    RECORDTYPES1_1: "",
  });
  const handleFieldChange = useCallback((name, value) => {
    console.log(name, value);
    // setformFields(prevState => ({
    //   ...prevState,
    //   [name]: value,
    // }));
    // updateSelectBoxOptions('SHIPPER', 'id', 'name', newOptions);
    // updateSelectBoxOptions('SHIPPER_5', 'id', 'name', newOptions);
    // updateSelectBoxOptions('SHIPPER_4', 'id', 'name', newOptions);
  }, []);

  const onFormLoad = useCallback(() => {
    updateSelectBoxOptions('SHIPPER', 'id', 'name', newOptions);
    updateSelectBoxOptions('SHIPPER_5', 'id', 'name', newOptions);
    updateSelectBoxOptions('SHIPPER_4', 'id', 'name', newOptions);
  })
  const updateSelectBoxOptions = useCallback((name, valueExpr, displayExpr) => {
    const ref = formRefs.current[name];
    if (ref) {
      ref.instance().option('dataSource', newOptions);
      ref.instance().option('valueExpr', valueExpr);
      ref.instance().option('displayExpr', displayExpr);
    }
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          {location.pathname === '/om/history/view-history' ? (
            <></>) : (
            <div id="accordion">

              <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={(e) => {
                  if (e.currentTarget === e.target) {
                    selectionChanged(e);
                  }
                }}
                itemTitleRender={() => (
                  <div className="header">
                    <div className="title">
                      <h6
                        style={{
                          marginLeft: "0px",
                          marginBottom: "0",
                          color: window._env_.Color2,
                          fontWeight: "700",
                        }}
                      >
                        Dynamic Form Layout
                      </h6>
                    </div>
                  </div>
                )}
                itemRender={(itemProps) => (
                  <>
                    <div className="col-md-3 d-flex justify-content-start">
                      <Button
                        id="button"
                        text="Save"
                        type="default"
                        icon='save'
                        useSubmitBehavior={true}
                      />
                    </div>
                    <ValidationSummary id="summary" />
                    <TabPanel>
                      <TabItem title="Tab 1">
                        <FormField
                          currrentUser={currentUser}
                          layoutId='43726C25-0433-41B6-8D24-B611BE1DD804'
                          layoutName='MyTestForm'
                          defaultFormSchema={defaultlayout}
                          formFields={formFields}
                          setformFields={setformFields}
                          handleFieldValueChange={handleFieldChange}
                          DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                          formRefs={formRefs}
                          onFormLoad={onFormLoad}
                        />
                      </TabItem>

                      <TabItem title="Tab 2">
                        <FormField
                          currrentUser={currentUser}
                          layoutId='7CC75C75-E6D0-49D3-A87B-8711E39D9F1A'
                          layoutName='MyTestForm'
                          defaultFormSchema={defaultlayout}
                          formFields={formFields}
                          setformFields={setformFields}
                          handleFieldValueChange={handleFieldChange}
                          DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                          formRefs={formRefs}
                          onFormLoad={onFormLoad}
                        />
                      </TabItem>

                      <TabItem title="Tab 3">
                        <FormField
                          currrentUser={currentUser}
                          layoutId='43726C25-0433-41B6-8D24-B611BE1DD638'
                          layoutName='MyTestForm'
                          defaultFormSchema={defaultlayout}
                          formFields={formFields}
                          setformFields={setformFields}
                          handleFieldValueChange={handleFieldChange}
                          DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                          formRefs={formRefs}
                          onFormLoad={onFormLoad}
                        />
                      </TabItem>
                    </TabPanel>

                    {/* </Item>
                        ))}
                      </DxTabPanel> */}



                  </>
                )}




                id="accordion-container" className="accordion-height"
              />


              {/* <OMTransactionHistoryGrid
                data={dataSource}
                searchPanelStatus={searchPanelStatus}
                selectedTab="History"
                initialDisableButton={true}
              /> */}
              {/* </form> */}
              <Button text="load data"
                onClick={() => updateSelectBoxOptions('SHIPPER', 'id', 'name')} />
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(OMTransactionHistorySearchForm);
